import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import TradeTypesTable from './tradeTypesTable';
import { getTradeTypes, deleteTradeType } from '../services/tradeTypeService';
import auth from '../services/authService';
import Spinner from './common/spinner';
import NotFound from './notFound';
import Alert from './common/alert';
//import AddButton from './common/addButton';

class TradeTypes extends Component {
  state = {
    ttypes: [],
    loading: false,
  };

  async componentDidMount() {
    this.setState({ loading: true });
    const ttypes_response = await getTradeTypes();
    this.setState({ loading: false });
    const { data: ttypes } = ttypes_response.data;
    this.setState({ ttypes });
  }

  handleDelete = async (ttype) => {
    const originalTradeTypes = this.state.ttypes;
    const ttypes = originalTradeTypes.filter((t) => t._id !== ttype._id);
    this.setState({ ttypes });

    try {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <Alert
              name="Trade Type"
              onClose={() => {
                this.setState({ ttypes: originalTradeTypes });
                onClose();
              }}
              onDelete={async () => {
                await deleteTradeType(ttype._id);
                onClose();
              }}
            />
          );
        },
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        toast('This Trade Type has already been deleted.');

      this.setState({ ttypes: originalTradeTypes });
    }
  };

  getPagedData = () => {
    const { ttypes } = this.state;

    return { data: ttypes };
  };

  render() {
    const { loading } = this.state;
    const { data: ttypes } = this.getPagedData();
    const { isAdmin } = auth.getCurrentUser();
    if (loading) return <Spinner message="loading page data..." />;
    return isAdmin ? (
      <React.Fragment>
        {/* <AddButton link="/trade-types/new" value="Add Trade Type" /> */}
        <TradeTypesTable
          ttypes={ttypes}
          onDelete={this.handleDelete}
          message="Trade Types"
        />
      </React.Fragment>
    ) : (
      <NotFound />
    );
  }
}

export default TradeTypes;
